import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const tileColorMap = {
    b: { bg: 'var(--brand-50)', border: 'var(--brand-100)', color: 'var(--brand-ink)' },
    v: { bg: 'var(--cleaning-bg)', border: '#E4D9FB', color: 'var(--cleaning)' },
    g: { bg: 'var(--done-bg)', border: 'var(--good-bd)', color: 'var(--good)' },
};

const AdminPage = () => {
    const { t } = useTranslation();

    const SETTINGS_GROUPS = [
        {
            title: t('settingsPage.workspace'),
            color: 'b',
            iconPath: <><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/></>,
            items: [
                { label: t('settingsPage.companyProfile'), desc: t('settingsPage.companyProfileDesc'), to: '/settings/company',
                  icon: <><path d="M3 21h18"/><path d="M5 21V7l8-4v18"/><path d="M19 21V11l-6-4"/><path d="M9 9v.01M9 12v.01M9 15v.01M9 18v.01"/></> },
            ],
        },
        {
            title: t('settingsPage.people'),
            color: 'b',
            iconPath: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
            items: [
                { label: t('settingsPage.users'),     desc: t('settingsPage.usersDesc'), to: '/settings/users',
                  icon: <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></> },
                { label: t('settingsPage.employees'), desc: t('settingsPage.employeesDesc'),  to: '/settings/employees',
                  icon: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></> },
            ],
        },
        {
            title: t('settingsPage.services'),
            color: 'v',
            iconPath: <><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></>,
            items: [
                { label: t('settingsPage.serviceCategories'), desc: t('settingsPage.serviceCategoriesDesc'), to: '/settings/service-categories',
                  icon: <><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></> },
            ],
        },
        {
            title: t('settingsPage.operations'),
            color: 'g',
            iconPath: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>,
            items: [
                { label: t('settingsPage.tagsTitle'), desc: t('settingsPage.tagsDesc'), to: '/settings/badges',
                  icon: <><circle cx="12" cy="8" r="6"/><path d="M8.56 2.9 7 1M15.44 2.9 17 1M12 14l-4 7h8l-4-7z"/></> },
            ],
        },
    ];

    return (
        <div className="sbr">
            <div className="dhead">
                <div>
                    <div className="ttl">{t('settingsPage.title')}</div>
                    <div className="sub">{t('settingsPage.configureWorkspace')}</div>
                </div>
            </div>

            {SETTINGS_GROUPS.map((group) => (
                <div key={group.title} style={{ marginBottom: '22px' }}>
                    {/* Section label */}
                    <div className="daygroup">
                        <svg className="ic" style={{ width: '15px', height: '15px', color: 'var(--brand)' }}
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            {group.iconPath}
                        </svg>
                        <span className="d">{group.title}</span>
                    </div>

                    {/* Items */}
                    {group.items.map((item) => {
                        const tc = tileColorMap[group.color] || tileColorMap.b;
                        return (
                            <Link key={item.to} to={item.to} style={{ textDecoration: 'none', display: 'block' }}>
                                <div className="card-sbr" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '14px 16px', marginBottom: '8px', cursor: 'pointer' }}>
                                    {/* Icon tile */}
                                    <div style={{
                                        width: '42px', height: '42px', borderRadius: '13px', flexShrink: 0,
                                        background: tc.bg, border: `1px solid ${tc.border}`, color: tc.color,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            {item.icon}
                                        </svg>
                                    </div>
                                    {/* Text */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div className="nm" style={{ fontSize: '14.5px', fontWeight: 700, color: 'var(--ink)', letterSpacing: '-.2px' }}>{item.label}</div>
                                        <div className="sub" style={{ fontSize: '12.5px', color: 'var(--muted)', fontWeight: 500, marginTop: '2px' }}>{item.desc}</div>
                                    </div>
                                    {/* Chevron */}
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#C4CCD8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                        <polyline points="9 18 15 12 9 6"/>
                                    </svg>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default AdminPage;
